// import React, { useEffect } from "react";
import { FaFilePdf, FaDownload } from "react-icons/fa";
import { DoubleColumn } from "../components";
import { About1Bg, About2Bg, About3Bg, DoubleColumnData } from "../assets";
// import Center from "./Center";
import MeetOurTeam from "./MeetOurTeam";

const auditReports = [
  { title: "Annual Report", year: "2024-25", groupYear: 2024, file: "/reports/Annual Report Bhavishya NGO 2024-25.pdf" },
  { title: "Financials", year: "2024-25", groupYear: 2024, file: "/reports/Signed Financials FY 2024-25.pdf" },
  { title: "Annual Report", year: "2023-24", groupYear: 2023, file: "/reports/Annual Report_Bhavishya_23-24.pdf" },
  { title: "Financials", year: "2023-24", groupYear: 2023, file: "/reports/Financials 2023-24.pdf" },
];

export default function About() {
  const DoubleColumnImgs = [About1Bg, About2Bg, About3Bg];
  const position = ["left", "right", "left"];
  const DoubleColumnColors = ["bg-[#FEF7ED]", "bg-[#FEF7ED]", "bg-[#FEF7ED]"];

  const reportsByYear = auditReports.reduce((groups, report) => {
    (groups[report.groupYear] = groups[report.groupYear] || []).push(report);
    return groups;
  }, {});
  const years = Object.keys(reportsByYear).sort((a, b) => b - a);

  return (
    <>
      <div className="">
        {DoubleColumnData.map((item, i) => (
          <div key={item.title}>
            <DoubleColumn
              title={item.title}
              description={item.description}
              img={DoubleColumnImgs[i]}
              position={position[i]}
              clrClass={DoubleColumnColors[i]}
            />
          </div>
        ))}
      </div>

      {/* <Center cardsToDisplay={3} /> */}
      <div className="text-center bg-[#FEF7ED]">
        <MeetOurTeam heading={"Meet Our Team"} isFirstRow="true" />
      </div>

      <div className="bg-[#FEF7ED] py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8 border-b border-gray-200 pb-6">
            <div className="text-left">
              <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">Annual Audit Reports</h2>
              <p className="text-gray-600 mt-2 max-w-xl">
                In the interest of transparency, we publish our annual audit reports and financial statements for public access.
              </p>
            </div>
            {auditReports.length > 0 && (
              <a
                href="/reports/Bhavishya_NGO_All_Reports.zip"
                download="Bhavishya_NGO_All_Reports.zip"
                className="inline-flex items-center justify-center gap-2 bg-[#ef5b5b] hover:bg-[#d94848] text-white font-bold px-5 py-3 rounded-lg shadow transition duration-300 w-full md:w-auto text-center shrink-0"
              >
                <FaDownload className="animate-bounce" size={16} />
                Download All Reports (.ZIP)
              </a>
            )}
          </div>
          {auditReports.length === 0 ? (
            <p className="text-center text-gray-400">Reports will be available here soon.</p>
          ) : (
            <div className="space-y-8">
              {years.map((year) => (
                <div key={year}>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 text-left">
                    {`${year}–${(Number(year) + 1).toString().slice(-2)}`}
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {reportsByYear[year].map((report) => (
                      <a
                        key={report.file}
                        href={report.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 border border-gray-200 rounded-lg p-4 bg-white hover:shadow-md transition"
                      >
                        <FaFilePdf className="h-8 w-8 text-red-500 shrink-0" size={32} />
                        <div className="text-left">
                          <p className="font-semibold text-gray-800">{report.title}</p>
                          <p className="text-sm text-gray-500">{report.year}</p>
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
